import { HttpClient } from '@angular/common/http';
import Constants from '../Constants';
import ChatEntry from '../models/chat/ChatEntry';
import { UrlBuilder } from '../models/frontend_entities/UrlBuilder';
import { AppData } from './AppData';
import { Observable } from 'rxjs';
import { ChatCounts } from '../models/chat/chat-counts.model';
import { inject, Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ChatService {

  readonly #http = inject(HttpClient);
  readonly #appData = inject(AppData);

  //endregion

  //region GETTER REQUESTS
  getChatEntries(chatId: string): Observable<ChatEntry[]> {
    const url: string = new UrlBuilder(
      Constants.URLS.chat.getEntries.replace('%1', chatId.toString())
    )
      .param('accessMode', this.#appData.getAccessMode())
      .build();

    return this.#http.get<ChatEntry[]>(url);
  }

  getNewChatEntries(chatId: string): Observable<ChatEntry[]> {
    const url: string = new UrlBuilder(
      Constants.URLS.chat.getNewEntries.replace('%1', chatId.toString())
    )
      .param('accessMode', this.#appData.getAccessMode())
      .build();

    return this.#http.get<ChatEntry[]>(url);
  }

  getChatCounts(chatId: string): Observable<ChatCounts> {
    const url: string = new UrlBuilder(
      Constants.URLS.chat.getCounts.replace('%1', chatId.toString())
    )
      .param('accessMode', this.#appData.getAccessMode())
      .build();

    return this.#http.get<ChatCounts>(url);
  }

  //endregion


  //region CREATE + UPDATE REQUESTS
  createChatForJob(jobId: string, checklistEntryId: string, message: string): Observable<ChatEntry> {
    const url: string = new UrlBuilder(
      Constants.URLS.chat.createChatForJob.replace('%1', jobId.toString())
    )
      .param('accessMode', this.#appData.getAccessMode())
      .param('checklistEntryId', checklistEntryId?.toString())
      .build();

    return this.#http.post<ChatEntry>(url, message || null);
  }

  createChatForMessage(messageId: string, message: string): Observable<ChatEntry> {
    const url: string = new UrlBuilder(
      Constants.URLS.chat.createChatForMessage.replace('%1', messageId.toString())
    )
      .param('accessMode', this.#appData.getAccessMode())
      .build();

    return this.#http.post<ChatEntry>(url, message || null);
  }


  createChatEntry(chatId: string, checklistEntryId: string, message: string): Observable<ChatEntry> {
    const url: string = new UrlBuilder(
      Constants.URLS.chat.createChatEntry.replace('%1', chatId.toString())
    )
      .param('accessMode', this.#appData.getAccessMode())
      .param('checklistEntryId', checklistEntryId?.toString())
      .build();

    return this.#http.post<ChatEntry>(url, message);
  }

  //endregion

}
